<template>
    <div>
        <swb-price-reply-search @showSearch="showSearch"></swb-price-reply-search>

        <div class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li v-for="(text, value) in priceReplyStateList" :class="{'current': value == priceReplyState}" @click="tabChange(value)" class="head-item">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <table class="custom-tbl" style="table-layout: auto" v-if="priceReplyState == 0">
            <thead class="head">
            <tr class="row">
                <th width="180" class="row align-left">询价单号</th>
                <th width="180" class="row align-left">标题</th>
                <th width="200" class="row align-left">询价公司</th>
                <th width="100" class="row align-left">报价总金额</th>
                <th width="200" class="row align-left">审核意见</th>
                <th width="180" class="row align-left">创建日期</th>
                <th width="220" class="row align-left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td class="row align-left">
                    <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id)">{{priceReply.inqryVoucherNo}}</a>
                </td>
                <td class="row align-left">{{priceReply.inqryTitle}}</td>
                <td class="row align-left">{{priceReply.inqryMerchantName}}</td>
                <td class="row align-right">{{priceReply.replyAmount}}</td>
                <td class="row align-left">{{priceReply.auditDesc}}</td>
                <td class="row align-left">{{priceReply.createTime}}</td>
                <td class="row align-left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceReplyInfo(priceReply.id)">查看</a>
                    <a v-if="checkActionPerm('apply') && priceReplyState == 0 && priceReply.auditState != 1 && priceReply.applyState != 1" class="swb-btn-link" @click="priceReplyApply(priceReply.id)">提交申请</a>
                    <a v-if="checkActionPerm('audit') && priceReplyState == 1 && postId == priceReply.auditorPostId" class="swb-btn-link" @click="priceReplyAudit(priceReply.id)">审核</a>
                    <a v-if="checkActionPerm('submit_to_upper') && priceReplyState == 2" class="swb-btn-link" @click="priceReplyPublish(priceReply.id)">呈报</a>
                    <a v-if="checkActionPerm('modify')" class="swb-btn-link" @click="priceReplyModife(priceReply.id)">修改</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceReplyVoucherTag(priceReply,priceReplyState)">设置标签</a>
                </td>
            </tr>
            </tbody>
        </table>

        <table class="custom-tbl" style="table-layout: auto" v-if="priceReplyState == 1 ||priceReplyState == 2">
            <thead class="head">
            <tr class="row">
                <th width="180" class="row align-left">询价单号</th>
                <th width="180" class="row align-left">标题</th>
                <th width="180" class="row align-left">询价公司</th>
                <th width="100" class="row align-left">报价总金额</th>
                <th width="180" class="row align-left">创建日期</th>
                <th width="220" class="row align-left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td class="row align-left">
                    <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id)">{{priceReply.inqryVoucherNo}}</a>
                </td>
                <td class="row align-left">{{priceReply.inqryTitle}}</td>
                <td class="row align-left">{{priceReply.inqryMerchantName}}</td>
                <td class="row align-right">{{priceReply.replyAmount}}</td>
                <td class="row align-left">{{priceReply.createTime}}</td>
                <td class="row align-left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceReplyInfo(priceReply.id)">查看</a>
                    <a v-if="checkActionPerm('apply') && priceReplyState == 0 && priceReply.auditState != 1 && priceReply.applyState != 1" class="swb-btn-link" @click="priceReplyApply(priceReply.id)">提交申请</a>
                    <a v-if="checkActionPerm('audit') && priceReplyState == 1 && postId == priceReply.auditorPostId" class="swb-btn-link" @click="priceReplyAudit(priceReply.id)">审核</a>
                    <a v-if="checkActionPerm('submit_to_upper') && priceReplyState == 2" class="swb-btn-link" @click="priceReplyPublish(priceReply.id)">呈报</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceReplyVoucherTag(priceReply,priceReplyState)">设置标签</a>
                </td>
            </tr>
            </tbody>
        </table>

        <table class="custom-tbl" style=" table-layout: auto;" v-if="priceReplyState == 3 || priceReplyState == 4">
            <thead class="head">
            <tr class="row">
                <th width="180" class="row align-left">询价单号</th>
                <th width="180" class="row align-left">标题</th>
                <th width="180" class="row align-left">询价公司</th>
                <th width="120" class="row align-left">报价总金额</th>
                <th width="170" class="row align-left">报价时间</th>
                <th width="170" class="row align-left">创建日期</th>
                <th width="220" class="row align-left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td class="row align-left">
                    <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id)">{{priceReply.inqryVoucherNo}}</a>
                </td>
                <td class="row align-left">{{priceReply.inqryTitle}}</td>
                <td class="row align-left">{{priceReply.inqryMerchantName}}</td>
                <td class="row align-right">{{priceReply.replyAmount}}</td>
                <td class="row align-left">{{priceReply.replyTime}}</td>
                <td class="row align-left">{{priceReply.createTime}}</td>
                <td class="row align-left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceReplyInfo(priceReply.id)">查看</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_inqry')" @click="toPriceInpryInfo(priceReply.inqryVoucherId)">查看询价</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceReplyVoucherTag(priceReply,priceReplyState)">设置标签</a>
                </td>
            </tr>
            </tbody>
        </table>

        <table class="custom-tbl" v-if="priceReplyState == 5" style=" table-layout: auto;">
            <thead class="head">
            <tr class="row">
                <th width="180" class="row align-left">询价单号</th>
                <th width="180" class="row align-left">标题</th>
                <th width="180" class="row align-left">询价公司</th>
                <th width="120" class="row align-left">报价总金额</th>
                <th width="160" class="row align-left">报价时间</th>
                <th width="160" class="row align-left">采纳时间</th>
                <th width="160" class="row align-left">创建日期</th>
                <th width="200" class="row align-left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td class="row align-left">
                    <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id)">{{priceReply.inqryVoucherNo}}</a>
                </td>
                <td class="row align-left">{{priceReply.inqryTitle}}</td>
                <td class="row align-left">{{priceReply.inqryMerchantName}}</td>
                <td class="row align-right">{{priceReply.replyAmount}}</td>
                <td class="row align-left">{{priceReply.replyTime}}</td>
                <td class="row align-left">{{priceReply.adoptedTime}}</td>
                <td class="row align-left">{{priceReply.createTime}}</td>
                <td class="row align-left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceReplyInfo(priceReply.id)">查看</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_inqry')" @click="toPriceInpryInfo(priceReply.inqryVoucherId)">查看询价</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceReplyVoucherTag(priceReply,priceReplyState)">设置标签</a>
                </td>
            </tr>
            </tbody>
        </table>
        <table class="custom-tbl" v-if="priceReplyState == 6" style=" table-layout: auto;">
            <thead class="head">
            <tr class="row">
                <th width="180" class="row align-left">询价单号</th>
                <th width="180" class="row align-left">标题</th>
                <th width="180" class="row align-left">询价公司</th>
                <th width="120" class="row align-left">报价总金额</th>
                <th width="160" class="row align-left">报价时间</th>
                <th width="160" class="row align-left">创建日期</th>
                <th width="160" class="row align-left">失效原因</th>
                <th width="200" class="row align-left">操作</th>
            </tr>
            </thead>
            <tbody class="body">
            <tr class="row" v-for="priceReply in priceReplyList">
                <td class="row align-left">
                    <a class="swb-btn-link" @click="toPriceReplyInfo(priceReply.id)">{{priceReply.inqryVoucherNo}}</a>
                </td>
                <td class="row align-left">{{priceReply.inqryTitle}}</td>
                <td class="row align-left">{{priceReply.inqryMerchantName}}</td>
                <td class="row align-right">{{priceReply.replyAmount}}</td>
                <td class="row align-left">{{priceReply.replyTime}}</td>
                <td class="row align-left">{{priceReply.createTime}}</td>
                <td class="row align-left">询价已结束</td>
                <td class="row align-left">
                    <a class="swb-btn-link" v-if="checkActionPerm('view')" @click="toPriceReplyInfo(priceReply.id)">查看</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('view_inqry')" @click="toPriceInpryInfo(priceReply.inqryVoucherId)">查看询价</a>
                    <a class="swb-btn-link" v-if="checkActionPerm('setTag')" @click="setPriceReplyVoucherTag(priceReply,priceReplyState)">设置标签</a>
                </td>
            </tr>
            </tbody>
        </table>
        <div class="pagination-layout mt10" v-if="totalCount > 0">
            <el-pagination background class="pagination-layout mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import userApi from '../../api/user'
    import priceApi from '../../api/price'

    import { showComAuditorSelectDlg } from '../merchant/showSelectDlg'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showComActionPostSelectDlg } from '../merchant/showSelectDlg'
    import { showBizAuditDlg } from '../merchant/showSelectDlg'
    import { checkUserActionPerm } from '../index'

    import SwbPriceReplyInfo from './PriceReplyInfo';

    Routes.add(SwbPriceReplyInfo);

    import SwbPriceInpryInfo from './PriceInpryInfo';

    Routes.add(SwbPriceInpryInfo);

    import SwbPriceApply from './PriceApply';

    Vue.regist(SwbPriceApply);

    import SwbPriceReplySearch from './PriceReplySearch'

    Vue.regist(SwbPriceReplySearch);

    import SwbPriceReplySave from './PriceReplySave';
    Routes.add(SwbPriceReplySave);
    export default {
        name: 'swb-price-reply-list',
        path: '/price/reply/voucher/list',
        pathOld: '/price/reply/list',
        avlActions: 'view|apply|audit|submit_to_upper|setTag|searchTag|view_inqry|modify',
        avlActionNames: '查看、提交申请、设置标签、搜索报价标签、审核、呈报、查看询价、',
        avlScopes: 'servicer',
        desc: '报价单列表',
        helpArticleCode: 'servicer-price-reply-voucher-list',
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                priceReplyList: [],
                priceReplyStateList: [],
                priceReplyState: 0,
                userInfo: {
                    userId: null,
                },
                postId: null,
                type: null,
            }
        },
        created: function () {
            let self = this;
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //----------------------查询------------------------------
            let inqryVoucherNo = this.$route.query.inqryVoucherNo || null;
            if(!Utils.isNoB(inqryVoucherNo)) {
                this.queryModel.filterItems.inqryVoucherNo = inqryVoucherNo;
                this.searchShow = true;
            }
            //
            self.userCurrentInfo();
            let checkState = this.$route.query.checkState || null;
            if(checkState != null) {
                self.getPriceReplyList(checkState);
            } else {
                self.getPriceReplyList(0);
            }
            // 过滤条件 枚举
            self.priceReplyStateList = getEnumMap('priceReplyState', 'value2text');
        },
        methods: {
            showSearch(data) {
                //1、接收查询条件
                this.queryModel = data;
                this.pageNumber = 1;
                this.getPriceReplyList(this.priceReplyState);

            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            tabChange: function (val) {
                this.pageNumber = 1;
                this.getPriceReplyList(val);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceReplyList(this.priceReplyState);
            },

            searchTag: function (tag) {
                this.tag = tag;
                this.searchShow = true;
                this.getPriceReplyList(this.priceReplyState);
            },

            userCurrentInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        self.userInfo = userInfo;
                        self.postId = userInfo.scopeEntity.postId;

                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            //获取列表信息
            getPriceReplyList: function (value) {
                let self = this;
                self.priceReplyState = value;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.priceReplyState = value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let loading = MsgBox.loading();
                priceApi.getPriceReplyVoucherList(postData, function (result) {
                    loading.close();
                    if(result.type == 'info') {
                        self.priceReplyList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // 申请
            priceReplyApply: function (id) {
                let self = this;
                showComActionPostSelectDlg({
                    rescUrl: Vue.$getClassInfo(this).path,
                    action: 'audit',
                }, function (resultData) {
                    resultData = resultData || {};
                    if(resultData.postId == null) {
                        Toast.show('请选 择审核岗位', 3000, 'warning');
                        return false;
                    }
                    //
                    let postData = {
                        id: id,
                        //
                        auditorPostId: resultData.postId,
                        auditorPostName: resultData.actionPostName,
                        //
                        applyDesc: resultData.applyDesc
                    };
                    let loading = MsgBox.loading();
                    priceApi.applyPriceReplyVoucher(postData, function (result) {
                        loading.close();
                        if(result.type == 'info') {
                            MsgBox.success('申请成功，等待审核');
                            self.getPriceReplyList(self.priceReplyState);
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },
            // 审核
            priceReplyAudit: function (id) {
                let self = this;

                showBizAuditDlg({
                    title: "报价 - 审核",
                    nextPostParams: {
                        rescUrl: Vue.$getClassInfo(self).path,
                        action: 'audit',
                    }
                }, function (resultData) {
                    resultData = resultData || {};
                    let nextPostResultData = resultData.nextPostResultData || null;
                    let auditorPostId = null;
                    if(nextPostResultData != null) {
                        auditorPostId = nextPostResultData.postId;
                    }
                    let postData = {
                        id: id,
                        auditState: resultData.auditState,
                        auditDesc: resultData.auditDesc,
                        auditorPostId: auditorPostId,
                    };
                    let loading = MsgBox.loading();
                    priceApi.auditPriceReplyVoucher(postData, function (result) {
                        if(result.type == 'info') {
                            loading.close();
                            MsgBox.success('操作成功');
                            self.getPriceReplyList(self.priceReplyState);
                        } else {
                            loading.close();
                            MsgBox.warning(result.message);
                        }
                    });
                }, this);
            },

            priceReplyModife: function (id) {
                this.$router.push({
                    path: SwbPriceReplySave.path,
                    query: {
                        priceVoucherId: id
                    }
                });
            },

            // 呈报
            priceReplyPublish: function (id) {
                let self = this;
                this.$confirm('是否确定呈报 ?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let loading = MsgBox.loading();
                    priceApi.replyPriceReplyVoucher(id, function (result) {
                        if(result.type == 'info') {
                            loading.close();
                            MsgBox.success('呈报成功，静等采纳……');
                            self.getPriceReplyList(self.priceReplyState);
                        } else {
                            loading.close();
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },

            // 查看详情
            toPriceReplyInfo: function (id, expireDate) {
                this.$router.push({
                    path: SwbPriceReplyInfo.path,
                    query: {
                        id: id,
                        checkState: this.priceReplyState,
                    }
                });
            },

            // 询价详情
            toPriceInpryInfo: function (id) {
                let hisUrl = Vue.$getClassInfo(this).path;
                this.$router.push({
                    path: SwbPriceInpryInfo.path,
                    query: {
                        id: id,
                        checkState: this.priceReplyState,
                        hisUrl: hisUrl
                    }
                });
            },

            setPriceReplyVoucherTag: function (row) {
                let self = this;
                Vue.$showDialog({
                    title: '设置标签',
                    showCloseBtn: true,
                    width: 530,
                    height: 300,
                    template: '<div>' +
                    '<div class="form-row spacing">' +
                    '<div class="form-label">' +
                    '<label>&nbsp;</label>' +
                    '</div>' +
                    '</div>' +
                    '<div class="form-row spacing">' +
                    '<div class="form-label">' +
                    '<label>标签</label>' +
                    '</div>' +
                    '<div class="form-value width-1-5x">' +
                    '<el-input type="text" v-model="tag"></el-input>' +
                    '</div>' +
                    '</div>' +
                    '</div>',
                    data: {
                        tag: row.tag
                    },
                    methods: {},
                    okClicked: function () {
                        let selfDlg = this;
                        row.tag = selfDlg.tag;
                        let loading = MsgBox.loading();
                        priceApi.updatePriceReplyVoucherTag(row, function (result) {
                            if(result.type === "info") {
                                loading.close();
                                MsgBox.success('设置成功!');
                            } else {
                                loading.close();
                                MsgBox.warning(result.message);
                            }
                        })
                    },
                    lifecycle: {}
                });
            },

        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceReply/PriceReplyList.vue